import { render, staticRenderFns } from "./ProgressBarStack.vue?vue&type=template&id=2604f50b&scoped=true"
import script from "./ProgressBarStack.vue?vue&type=script&lang=js"
export * from "./ProgressBarStack.vue?vue&type=script&lang=js"
import style0 from "./ProgressBarStack.vue?vue&type=style&index=0&id=2604f50b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2604f50b",
  null
  
)

export default component.exports